import { render, staticRenderFns } from "./mcpro-return.vue?vue&type=template&id=6c04a288&"
import script from "./mcpro-return.ts?vue&type=script&lang=ts&"
export * from "./mcpro-return.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports